import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants/endpoint';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetOrderOutboundOrderCodeParams, TypeGetOrderOutboundOrderCodeResponse } from '~/types/order.types';

const useGetOrderOutboundOrderCode = () => {
  const { runAsync } = useAsyncHandler();

  const getOrderOutboundOrderCode = useAPI<TypeGetOrderOutboundOrderCodeParams, TypeGetOrderOutboundOrderCodeResponse>({
    endpoint: API_ENDPOINT.ORDER.GET_ORDER_OUTBOUND_ORDER_CODE,
    method: 'get',
  });

  const requestOrderDetail = async (
    params: TypeGetOrderOutboundOrderCodeParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: (data: TypeGetOrderOutboundOrderCodeResponse['data']) => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => getOrderOutboundOrderCode({ pathParams: `/${params.outboundOrderCode}` }), {
      onSuccess: ({ data }) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => {
        onError?.(error);
      },
    });
  };

  return { requestOrderDetail };
};

export default useGetOrderOutboundOrderCode;
